export default __webpack_public_path__ + "static/media/speaker2@3x.3c1467b7.png";